import React from "react";
import Slider from "react-slick";

const BlogSection = () => {

  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 700,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } }
    ]
  };

  const blogs = [
    {
      image: "/images/keyword/1.jpg",
      author: "Velocity Cab",
      title: "Pune to Mumbai Cab",
      link: "/Pune-to-Mumbai-Cab"
    },
    {
      image: "/images/keyword/55.jpg",
      author: "Velocity Cab",
      title: "Thane to Pune Cabs",
      link: "/Thane-to-Pune-Cab"
    },
    {
      image: "/images/keyword/78.jpg",
      author: "Velocity Cab",
      title: "Mumbai to Goa Cabs",
      link: "/Mumbai-to-Goa-Cab"
    }
  ];

  return (
    <div className="section-full py-5 site-bg-white twm-blog-section-wrap">
      <div className="container">

        {/* Title */}
        <div className="section-head center">
          <div className="twm-sm-title left">From the Blog</div>
          <h2 className="twm-large-title site-text-dark">
               Cab Services & Travel Tips
          </h2>
        </div>

        {/* Carousel */}
        <div className="section-content">
          <Slider {...settings} className="twm-blog-carousel m-b30">

            {blogs.map((blog, index) => (
              <div className="item px-2" key={index}>
                {/* px-2 adds horizontal padding */}
                <div className="twm-blog-grid-2">

                  <div className="wt-post-media">
                    <a href={blog.link}>
                      <img src={blog.image} alt={blog.title} />
                    </a>
                  </div>

                  <div className="twm-post-info-wrap">
                    <div className="twm-post-info">
                      <div className="post-author">
                        <a className="au-name" href={blog.link}>
                          by {blog.author}
                        </a>
                      </div>
                      <h3 className="post-title">
                        <a href={blog.link}>{blog.title}</a>
                      </h3>
                    </div>
                  </div>

                </div>
              </div>
            ))}

          </Slider>
        </div>

      </div>
    </div>
  );
};

export default BlogSection;